import Vue from 'vue'
import App from './App.vue'
import router from './router'
// Scroll for menu
import VueScrollTo from 'vue-scrollto'

// Autocomplete for select town
import Autocomplete from 'v-autocomplete'
// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-autocomplete/dist/v-autocomplete.css'

// swiper for diploms
import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueScrollTo)
Vue.use(Autocomplete)
Vue.use(VueAwesomeSwiper) // , /* { default global options } */)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
